import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import _ from 'underscore';
import { Manifest } from 'services/action';

import { DatePicker, Select } from 'ui/components';

import { formatDate } from 'utilities/common';

const now = new Date();
const nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

const actionOptions = [
  { value: 'redelivery', label: 'Kirim Ulang' },
  { value: 'return', label: 'Kembalikan' },
];

const initialState = {
  selectedAction: null,
  showReceive: false,
  isLoading: false,
  redeliveryAt: null,
};

export const ActionReceived = ({
  manifest,
  legs,
  onSubmit,
  handleClose,
  loading = false,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ showReceive, isLoading, redeliveryAt, selectedAction }, setState] = React.useState(initialState);

  const $handleReceive = () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
  };

  const $handleClose = async () => {
    setState((prevState) => ({
      ...prevState,
      showReceive: false,
    }));
  };

  const $handleSelectedAction = (e) => {
    let redeliveryAt = null

    if (e?.value === 'redelivery') {
      redeliveryAt = {
        default: nextDay,
        formatted: formatDate(nextDay, 'YYYY-MM-DD'),
      }
    }

    setState((prevState) => ({
      ...prevState,
      selectedAction: e,
      redeliveryAt: redeliveryAt,
    }));
  };

  const closeProcess = () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: false,
      showReceive: false
    }));

    if (onSubmit) onSubmit();
  }

  const closeLoading = () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: false,
    }));
  }

  const $onReceive = () => {
    _.each(legs?.jobs, async (j, i) => {
      if (j.status === 'delivered' || j.status === 'unreceived') {

        const payload = {redelivery_at: redeliveryAt?.formatted || '', action: selectedAction?.value}
        const req = await Dispatch(Manifest.$receive(manifest?.id, legs?.id, j.id, payload));
        if (req?.message === 'success') {
          if (i === (legs?.jobs?.length - 1)) {
            closeProcess();
          }
        }else{
          closeLoading()
        }
      }
    });
  }

  React.useEffect(() => {
    if (isLoading) {
      $onReceive();
    }
  }, [isLoading]);



  return (
    <div>
      <div className="card-footer-gray  border-top p-3">
        <button
          className={cn(
            'btn btn-sm btn-success w-100',
            isLoading ? 'btn-loading' : ''
          )}
          onClick={() =>
            setState((prevState) => ({
              ...prevState,
              showReceive: true,
            }))
          }
        >
          Terima Semua
        </button>
      </div>

      <Modal
        show={showReceive}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin semua shipment telah diterima di lokasi?</h3>

          {manifest?.type === 'last_mile' && (
            <div className="mb-2 text-start">
              <label className='form-label required'>Tidak Lanjut</label>
              <Select
                required
                isClearable
                classNamePrefix={
                  StateForm?.errors?.repeat_type ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={selectedAction}
                options={actionOptions}
                onChange={$handleSelectedAction}
                error={StateForm?.errors?.action}
              />

              {StateForm?.errors?.action ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.action}
                </div>
              ) : null}
            </div>
          )}

          {selectedAction?.value === 'redelivery' && (
            <div className="mb-2 text-start">
              <label className="form-label fs-8 required">Jadwal Pickup</label>
              <div
                className={
                  StateForm?.errors?.etd_at
                  ? 'border border-danger rounded'
                  : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={redeliveryAt?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) =>
                    setState((prevState) => ({
                      ...prevState,
                      redeliveryAt: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }))
                  }
                  isShowTrigger
                />
              </div>
              {StateForm?.errors?.redelivery_at && (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.redelivery_at}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={isLoading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $handleReceive()}
                disabled={isLoading}
              >
                Terima
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
